import { Vue, Component } from 'vue-property-decorator';
import { SearchModule } from '~/store/modules/search';

@Component
export default class Search extends Vue {
    async search(searchText: string, paramType?: string, prefix?: string) {
        await SearchModule.search({ searchText, paramType, prefix });
    }

}
